import * as urlUtils from "@arcgis/core/core/urlUtils.js";
import Basemap from "@arcgis/core/Basemap.js";
import WebMap from "@arcgis/core/WebMap.js";
import MapView from "@arcgis/core/views/MapView.js";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer.js";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";

const symbol = {
    type: "simple-fill",
    color: [123, 123, 236, 0],
    style: "solid",
    outline: {
        style: "short-dot",
        color: "white",
        width: 2
    }
};

export default function initializeMap(basemapUrl, parcelUrl, center) {
    return new Promise((resolve, reject) => {
        // Add proxy rule
   //     if (!document.location.href.includes("localhost")){
            urlUtils.addProxyRule({
                urlPrefix: "maps.wingis.org",
                proxyUrl: "/proxy"
            });
     //   }



        // Create WebMap
        const map = new WebMap({
 //           basemap: basemap,
            layers: []
        });

        // Create MapView
        const view = new MapView({
            container: "summaryMap",
            map: map,
            // spatialReference: {
            //     wkid: 3436
            // },
            padding: {
                top: 50,
                bottom: 0
            },
            ui: { components: [] },
            center: center,
            zoom: 8
        });

        // Event handlers to stop certain interactions
        view.on("key-down", (event) => {
            const prohibitedKeys = ["+", "-", "Shift", "_", "="];
            const keyPressed = event.key;
            if (prohibitedKeys.includes(keyPressed)) {
                event.stopPropagation();
            }
        });
        view.on("mouse-wheel", (event) => {
            event.stopPropagation();
        });
        view.on("double-click", (event) => {
            event.stopPropagation();
        });
        view.on("drag", (event) => {
            event.stopPropagation();
        });
        view.on("drag", ["Shift"], (event) => {
            event.stopPropagation();
        });
        view.on("drag", ["Shift", "Control"], (event) => {
            event.stopPropagation();
        });

        // Create MapImageLayer
        const parcels = new MapImageLayer({
            url: parcelUrl,
        });

        map.add(parcels);
        view.padding = 0;

        // Create TileLayer
        const orthos = new MapImageLayer({
            url: basemapUrl, // url to the service
        });

        // Create Basemap
        map.add(orthos); 
        // const basemap = new Basemap({
        //     baseLayers: [orthos],
        //     title: "basemap",
        //     id: "1",
        // });

  //      map.basemap = basemap;
        resolve([map, view]);
    });
}

export function zoomToGeometry(view, geometry) {
    const highlightGraphic = {
        geometry: geometry,
        symbol: symbol
    };

    view.graphics.add(highlightGraphic);

    let extent = geometry.extent; 
    extent.xmax += 300;
    extent.xmin -= 300;
    extent.ymax += 300;
    extent.ymin -= 300;
    
    view.extent = extent; 
    

    return new Promise((resolve, reject) => {
        (async () => {
            await reactiveUtils.whenOnce(() => !view.updating);
            resolve(); 
        })();
    })
}
